import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import Remote from "../components/equipments/Remote";
import Thermostat from "../components/equipments/Thermostat";
import Humidity from "../components/equipments/Humidity";
import RoomEquipmentsList from "../components/RoomEquipmentsList";

const HumidityPage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "رطوبت",
      slug: "home",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
      <div className="container-xxl flex-grow-1 container-p-y">
        {/* Layout Demo */}
        <Humidity />
        <RoomEquipmentsList />
        {/*/ Layout Demo */}
      </div>
    </HelmetProvider>
  );
};

export default HumidityPage;
